<template>
  <section class="video-card">
    <router-link target="_blank" :to="'/video/detail?id='+item.videoId">
      <img
        class="videothump"
        @mouseenter="showSometing"
        @mouseleave="hiddenSometing"
        :src="item.thumb | imageUrl('', 700, 394)"
      />
      <!-- <p>{{item.title}}</p> -->
      <p v-if="language=='zh'" v-html="item.title"></p>
      <p v-else v-html="item.enTitle || item.title"></p>
      <!-- <span class="add"></span> -->
      <span class="play" :class="{show:focus}" @mouseenter="showSometing">
        <img src="/static/v2/match/play_tri_40.png" alt />
      </span>
      <span
        class="videotime"
        :class="{show:focus}"
        @mouseenter="showSometing"
      >{{item.duration | secondToDate}}</span>
    </router-link>
    <div class="industryList">
      <!-- <div class="industryListLeft" v-if="language==='zh'">
        <span v-for="it in item.professionList" :key="it.id">{{it.title}}</span>
      </div>
      <div class="industryListLeft" v-if="language!=='zh'">
        <span v-for="it in item.professionList" :key="it.id">{{it.titleEn}}</span>
      </div> -->
      <div class="industryListLeft">
        <span v-for="it in item.categoryTagGroupInfoList" :key="it.id">{{it}}</span>
      </div>
      <div class="userright">
        <img src="/static/v2/article/view_icon.png" />
        <span>{{item.viewCount}}</span>
      </div>
    </div>
    <router-link
      :to="`/peopleCenter/${item.userId}`"
      target="_blank"
      class="user-info"
      v-if="!isUser"
    >
      <div :class="{'userType2':item.userType === 2 && item.isCertification === 1}">
        <img :src="item.userAvatar | imageUrl('/static/profile_img_default.png', 100, 100)" />
        <span>{{item.userNickName}}</span>
      </div>
    </router-link>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      focus: false
    };
  },
  props: ["item", "language", "isUser"],
  methods: {
    showSometing() {
      this.focus = true;
    },
    hiddenSometing() {
      this.focus = false;
    },
    delStyleTag(str) {
      return str
        .replace(/<style((?!<\/style>).)*<\/style>/g, "")
        .replace(/&lt;/g, "<")
        .replace(/↵/g, "")
        .replace(/<[^>]+>/g, "");
    }
  }
};
</script>

<style lang="stylus" scoped>
.video-card {
  .industryList {
    color: #999;
    line-height: 17px;
    padding: 0;
    overflow: hidden;

    .industryListLeft {
      float: left;
      width: 280px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      span {
        font-size: 12px;
        margin-right: 8px;
      }
    }

    .userright {
      float: right;
      display: flex;
      align-items: center;

      img {
        position: relative;
        width: 18px;
        height: 12px;
        margin-right: 3px;
      }
    }
  }

  .user-info {
    display: block;
    margin-top: 5px;

    div {
      &.userType2::before {
        content: '';
        left: 18px;
        bottom: 2px;
        position: absolute;
        width: 10px;
        height: 10px;
        background: url('/static/v2/match/Verified_icon_blue_20.png');
        background-size: 10px;
      }

      img {
        width: 26px;
        height: 26px;
        margin-right: 6px;
        border-radius: 100%;
      }

      span {
        position: relative;
        top: 2px;
        font-size: 12px;
        font-family: NunitoSans-Regular, NunitoSans;
        max-width: 300px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
        white-space: nowrap;
        color: #666;
        vertical-align: sub;

        &:hover {
          color: #0A0A0A;
        }
      }
    }
  }

  a {
    position: relative;
    display: block;

    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #0A0A0A;
      height: 20px;
      padding: 10px 0 5px;
      font-size: 15px;
      font-family: NunitoSans-Bold, NunitoSans;
      font-weight: bold;
    }

    .videothump {
      width: 100%;
      height: 197px;
    }

    .videotime {
      position: absolute;
      display: none;
      top: 170px;
      right: 10px;
      padding: 2px 8px;
      color: #fff;
      background: #0A0A0A;
      border-radius: 2px;
    }

    .play {
      position: absolute;
      display: none;
      left: 160px;
      top: 79px;
      cursor: pointer;

      img {
        width: 30px;
        height: 40px;
      }
    }

    .show {
      display: inline-block;
    }
  }

  .video-player {
    height: 411px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/v2/peopleCenter/VideoCard2.vue